import { CustomFieldDataType } from 'shared'
import { CIMSSingleColumn } from '../../../../CIMSTable/CIMSColumn/types'
import { ProjectCustomField } from '../../../ProjectCustomFieldsContext/types'
import { WithRenderedCustomFields } from '../../../types'

export function width<T extends WithRenderedCustomFields>({
  customField,
  filter,
  sort,
}: WidthOptions): CIMSSingleColumn<T>['width'] {
  const { name, description, dataTypeId } = customField
  const { timestamp } = customField.metadata
  /**
   * returns a css function to get the max of either the {@link width} or
   * the desired max width
   *
   * @param width the desired max width
   */
  const max = <T extends number>(maxWidth: T) => {
    let width = name.length + 'ch'
    /**
     * a description enables the help icon
     */
    if (description) width += ' + 22px'
    if (sort) width += ' + 15px'
    if (filter) width += ' + 20px'
    /**
     * adding 32 to account for 16px x-padding
     */
    width += ' + 32px'
    return `max(calc(${width}), ${maxWidth}px)` as const
  }

  if (dataTypeId === CustomFieldDataType.Date.id) {
    if (timestamp) return max(140)
    return max(105)
  } else if (dataTypeId === CustomFieldDataType.List.id) return max(150)
  else if (dataTypeId === CustomFieldDataType.Entity.id) return max(150)
  else if (dataTypeId === CustomFieldDataType.Report.id) return max(150)
  else return max(120)
}

type WidthOptions = {
  customField: ProjectCustomField
  sort?: boolean
  filter?: boolean
}
